import { Box } from '@mui/material';
import { useEffect, useState } from 'react';
import { LoadingIndicator } from '@xolv-mybrightlink/common';
import { createLessonDetailUrl } from '../services/LessonService';
import { useIntl } from 'react-intl';

export function LessonDetail({
  lessonId,
  hasQuiz,
  firstLessonId,
  lastLessonId,
}: {
  lessonId: string;
  hasQuiz: boolean;
  firstLessonId: string;
  lastLessonId: string;
}) {
  const [lessonUrl, setLessonUrl] = useState('');
  const [loading, setLoading] = useState(false);
  const intl = useIntl();

  useEffect(() => {
    (async function () {
      setLoading(true);
      try {
        const lessonDetailUrl = await createLessonDetailUrl(
          intl,
          lessonId,
          hasQuiz,
          lessonId === firstLessonId ? '0' : '1',
          lessonId === lastLessonId ? '0' : '1',
        );
        setLessonUrl(lessonDetailUrl);
      } catch (e) {
        console.warn(e);
      } finally {
        setLoading(false);
      }
    })();
  }, [firstLessonId, hasQuiz, intl, lastLessonId, lessonId]);

  const content = (
    <>
      <Box sx={{ boxSizing: 'border-box', width: 1, height: 1 }}>
        <iframe
          width='100%'
          height='100%'
          src={lessonUrl}
          style={{ border: 0 }}
        ></iframe>
      </Box>
    </>
  );

  return loading ? (
    <Box
      sx={{
        boxSizing: 'border-box',
        height: 1,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <LoadingIndicator />
    </Box>
  ) : (
    content
  );
}
